"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, Vue, Ref } from "vue-property-decorator";
import UiDialog from "@/components/dialog/UiDialog.vue";
import API from "@ym-framework/api-utils";
let OverFlowDialog = class extends Vue {
  constructor() {
    super(...arguments);
    this.flowDatas = [];
    this.canClose = false;
    this.countdown = 5;
    this.timer = null;
  }
  open(datas) {
    return __async(this, null, function* () {
      this.flowDatas = datas;
      this._overflowdialog.show();
      this.startCountdown();
    });
  }
  toOrder() {
    return __async(this, null, function* () {
      try {
        this.$router.push("/cost#OrderManage");
        yield API.put(`api://base.local/storages/session/flow_overrange`, {
          message: "has.check.flow_overranges",
          model: "has.check.flow_overranges"
        });
      } catch (error) {
        console.log(error);
      }
    });
  }
  startCountdown() {
    this.canClose = false;
    this.countdown = 5;
    this.timer = setInterval(() => {
      this.countdown--;
      if (this.countdown <= 0) {
        this.canClose = true;
        clearInterval(this.timer);
      }
    }, 1e3);
  }
  close() {
    return __async(this, null, function* () {
      try {
        if (this.canClose) {
          this._overflowdialog.hide();
          if (this.timer) {
            clearInterval(this.timer);
          }
          yield API.put(`api://base.local/storages/session/flow_overrange`, {
            message: "has.check.flow_overranges",
            model: "has.check.flow_overranges"
          });
        }
      } catch (error) {
        console.log(error);
      }
    });
  }
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  }
};
__decorateClass([
  Ref("overflowdialog")
], OverFlowDialog.prototype, "_overflowdialog", 2);
OverFlowDialog = __decorateClass([
  Component({
    components: {
      UiDialog
    }
  })
], OverFlowDialog);
export {
  OverFlowDialog as default
};
